import type { Constructor } from '../types';
import VoteControl from '../controls/VoteControl';
import type ShapePersistentControlBehaviors from './ShapePersistentControlBehaviors';
import type { ShapePersistentControlBehaviorsConstructor } from './ShapePersistentControlBehaviors';

// Functionality to support voting on objects.
interface VotingBehaviors {
  __hasVotingBehaviors: boolean;
  votingResultIcon: JSX.Element;
  votingResultSummary: string;
}

const votableClasses: Array<ShapePersistentControlBehaviorsConstructor> = [];

// eslint-disable-next-line @typescript-eslint/no-redeclare
function VotingBehaviors(
  Base: Constructor<fabric.Object & ShapePersistentControlBehaviors>
): any {
  votableClasses.push(
    // We know that ShapePersistentControlBehaviors has a constructor
    // named after the same thing, and it's typechecked in the
    // behavior file. But it can't return the correct type because the
    // decorator pattern can't handle that.
    Base as unknown as ShapePersistentControlBehaviorsConstructor
  );

  return class WithVotingBehaviors extends Base {
    __hasVotingBehaviors = true;
  };
}

VotingBehaviors.enable = function enableVotingBehaviors() {
  votableClasses.forEach(cls => {
    if (!cls.persistentControls.vote) {
      cls.persistentControls.vote = new VoteControl({ x: 0.5, y: -0.5 });
    }
  });
};

VotingBehaviors.disable = function disableVotingBehaviors() {
  votableClasses.forEach(cls => {
    delete cls.persistentControls.vote;
  });
};

export default VotingBehaviors;
